import { useState } from "react";
import WhatsappIcon from "./WhatsappIcon";
import "./style.scss";

export default function WhatsappButton({
  phone = "5511914569309",
  message = "Olá, preciso de ajuda com a plataforma 121 Insights CX",
}) {
  const [hover, setHover] = useState(false);
  const url = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(
    message
  )}&type=phone_number&app_absent=0`;

  return (
    <a
      className={`whatsapp__button ${hover ? "active" : ""}`}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      title="Falar com suporte no WhatsApp"
    >
      <WhatsappIcon />
      {hover && <span className="whatsapp__title">Suporte 121Labs/Hazo</span>}
    </a>
  );
}
